import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=1cf16d7d&scoped=true&"
import script from "./qrcode.vue?vue&type=script&lang=js&"
export * from "./qrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf16d7d",
  null
  
)

export default component.exports